// extracted by mini-css-extract-plugin
module.exports = {"PageProduct":"product_PageProduct__fnxeb"};